export const environment = {
  production: true,
  title: 'Production Environment Config',
  base_url: location.protocol + '//' + location.hostname + (location.port == "" ? ""  : ":"+location.port) + '/api/v1',
  broker: location.hostname ,
  protocol: location.protocol== 'http:' ? 'ws' : 'wss',
  port: Number(location.port),
  path:'/mqtt',
};
